import ajusteContaServices from '@/api/financialModule/ajusteContaServices'

export default {
  findAll({ commit }, pageConfig) {
    return new Promise((resolve, reject) =>
      ajusteContaServices
        .findAll(pageConfig)
        .then(result => {
          commit('LOAD_LIST_AJUSTES', result.data.content)
          resolve(result)
        })
        .catch(err => reject(err))
    )
  },
  findById({ commit }, id) {
    return ajusteContaServices.findById(id).then(result => result).catch(error => error)
  },
  insert({ commit }, data) {
    return ajusteContaServices.insert(data).then(result => result).catch(error => error)
  },
  filtroAjustes({ commit }, { filter, pageConfig }) {
    return new Promise((resolve, reject) =>
      ajusteContaServices
        .filtro(filter, pageConfig)
        .then(result => {
          commit('LOAD_LIST_AJUSTES', result.data.content)
          resolve(result)
        })
        .catch(err => reject(err))
    )
  },
  deleteAjuste({ commit }, id) {
    return ajusteContaServices.delete(id).then(result => result).catch(error => error)
  },
  reset({ commit }) {
    commit('RESET_AJUSTE')
  }
}
